export const ORGANIZATION_UPDATE_INIT = 'ORGANIZATION_UPDATE_INIT';
export const ORGANIZATION_UPDATE = 'ORGANIZATION_UPDATE';

export const ORGANIZATION_FETCH = 'ORGANIZATION_FETCH';
export const ORGANIZATION_FETCH_INIT = 'ORGANIZATION_FETCH_INIT';
export const ORGANIZATION_FETCH_DONE = 'ORGANIZATION_FETCH_DONE';
